import React, {useEffect, useMemo, useState} from "../../../../__snowpack__/pkg/react.js";
import {Select, Form, Modal, Radio, Space} from "../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {useIntlTyped} from "../../../lib/useIntlTyped.js";
import {useWrapSync} from "../../../lib/useWrapSync.js";
import {localeMessage} from "../i18n.js";
import {useSelectedKeysModel} from "../store.js";
import {useUpdateRoute} from "../../../lib/useIframe.js";
import {eventLogger} from "../../../lib/eventLogger.js";
import ChannelIcon from "../../../components/ChannelIcon.js";
export const usePublishToStoreModal = () => {
  const [visible, setVisible] = useState(false);
  return {
    publishToStoreModalVisible: visible,
    setPublishToStoreModalVisible: setVisible
  };
};
export const PublishToStoreModal = (props) => {
  const {shops = [], onChange, nextLogParams} = props;
  const {formatMessage, formatMessageMock} = useIntlTyped(localeMessage);
  const {selectedKeys} = useSelectedKeysModel();
  const [form] = Form.useForm();
  const [countryCode, setCountryCode] = useState();
  const {updateRoute} = useUpdateRoute();
  const countries = useMemo(() => {
    return shops.reduce((acc, cur) => {
      if (!acc.find((_) => _.countryCode === cur.countryCode)) {
        acc.push(cur);
      }
      return acc;
    }, []);
  }, [shops]);
  const filterShops = useMemo(() => {
    if (countryCode === void 0) {
      return;
    }
    return shops.filter((_) => {
      return !["TIKI_ID", "JD_V2", "ZALORA_ID", "AKULAKU_ID", "JD_TH", "GINEE_POS"].includes(_.channelId) && _.countryCode === countryCode;
    });
  }, [shops, countryCode]);
  const {wrapSync: wrapSubmitHandler, loading: submitHandlerLoading} = useWrapSync();
  const submitHandler = wrapSubmitHandler(async () => {
    try {
      const values = await form.validateFields();
      sessionStorage.setItem("product-local-publish/publishToStore", JSON.stringify({
        ...values,
        shopList: values.shopIds.map((_) => {
          return filterShops?.find((item) => item.id === _);
        }),
        productIds: selectedKeys
      }));
      updateRoute("product-local-publish");
      onChange && onChange();
    } catch (error) {
      return;
    }
  });
  useEffect(() => {
    if (props.visible) {
      const countryCode2 = countries.find((_) => _)?.countryCode;
      setCountryCode(countryCode2);
      form.resetFields();
      form.setFieldsValue({
        countryCode: countryCode2
      });
    }
  }, [props.visible, countries]);
  return /* @__PURE__ */ React.createElement(ModalWrapper, {
    title: formatMessage({id: "chooseDestinationStore"}),
    confirmLoading: submitHandlerLoading,
    okText: formatMessage({id: "nextStep"}),
    onOk: () => {
      if (nextLogParams) {
        eventLogger.push({
          action: nextLogParams?.action,
          location: nextLogParams?.location
        });
      } else {
        eventLogger.push({
          action: "ClickNextStep",
          location: "MasterPublishChooseDestinationStore"
        });
      }
      submitHandler();
    },
    onCancel: () => {
      props.onCancel && props.onCancel();
    },
    ...props
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "country"}),
    name: "countryCode"
  }, /* @__PURE__ */ React.createElement(Radio.Group, {
    onChange: (val) => {
      setCountryCode(val.target.value);
      form.resetFields(["shopIds"]);
    }
  }, countries.map((_) => {
    return /* @__PURE__ */ React.createElement(Radio, {
      key: _.countryCode,
      value: _.countryCode
    }, _.country);
  }))), /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: true,
    noStyle: true
  }, () => {
    return /* @__PURE__ */ React.createElement(Form.Item, {
      label: formatMessage({id: "storeName"}),
      name: "shopIds",
      rules: [
        {
          required: true,
          message: formatMessage({id: "pleaseChoose"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      mode: "multiple",
      allowClear: true,
      getPopupContainer: (triggerNode) => triggerNode.parentNode,
      placeholder: formatMessage({id: "selectStore"}),
      optionFilterProp: "title",
      filterOption: (input, option) => {
        if (option?.title) {
          return option.title.toLowerCase().includes(input.toLowerCase());
        }
        return true;
      }
    }, filterShops && filterShops.map((item) => /* @__PURE__ */ React.createElement(Select.Option, {
      value: item.id,
      key: item.id,
      title: item.shopName
    }, /* @__PURE__ */ React.createElement(Space, {
      align: "center"
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: item.channelId
    }), /* @__PURE__ */ React.createElement("span", null, "(", item?.countryCode, ")"), /* @__PURE__ */ React.createElement("span", null, item.shopName))))));
  })));
};
const ModalWrapper = styled(Modal)`
  .ant-modal-body {
    margin-bottom: -16px;
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .custom-input-group {
    display: flex;
    .ant-input-number {
      flex: 1;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .custom-input-group-handler {
    .ant-input-number-handler-wrap {
      display: block;
      opacity: 1;
    }
  }
  .ant-input-textarea-show-count:after {
    margin-top: 8px;
    font-size: 10px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 12px;
  }
  .ant-input-textarea textarea {
    min-height: 75px;
  }
  .select-checkbox {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }
  .ant-select-selection-overflow {
    display: flex;
    flex-wrap: wrap;
  }
`;
